import { render } from "./index.vue?vue&type=template&id=48e4f2fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=48e4f2fa&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e4f2fa"],['__file',"src/views/food/desk/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48e4f2fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48e4f2fa', __exports__)) {
    console.log('reload')
    api.reload('48e4f2fa', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=48e4f2fa&scoped=true", () => {
    console.log('re-render')
    api.rerender('48e4f2fa', render)
  })

}


export default __exports__